import { render, staticRenderFns } from "./FlexmessageCreate.vue?vue&type=template&id=226df53e&scoped=true&"
import script from "./FlexmessageCreate.vue?vue&type=script&lang=js&"
export * from "./FlexmessageCreate.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageCreate.vue?vue&type=style&index=0&id=226df53e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226df53e",
  null
  
)

export default component.exports